import API from '../api'
import { ItemClasses } from '../../common/constants'
import { CatalogItem } from '../../domain/catalogItem'
import { ItemCategory } from '../../domain/itemCategory'
import { CatalogTemplateWithItems } from '../../domain/catalogTemplate'
import { message } from 'antd'
import { CatalogItemFormValues, UpdateJobDescription } from './catalogItemModel'

export const loadItemCatalogEndpoint = '/web/catalog-items'

export const loadItemCatalog = async (searchQuery: string, page: number, pageSize: number, classIds: number[], categories: string[], retired: boolean): Promise<CatalogItem[]> => {
  return (await API.get<{ items: CatalogItem[] }>(loadItemCatalogEndpoint, {
    params: {
      searchQuery,
      page,
      pageSize,
      classIds: classIds.join(','),
      categories: categories.join(','),
      retired
    }
  })).data.items
}

export const loadItemCategoriesEndpoint = '/items/categories'

export const loadItemCategories = async (): Promise<ItemCategory[]> => {
  return (await API.get<ItemCategory[]>(loadItemCategoriesEndpoint)).data
}

export const loadCatalogTemplatesEndpoint = '/web/catalog-items/templates'

export const loadCatalogTemplates = async (searchQuery: string, page: number, pageSize: number, categories: string[]): Promise<CatalogTemplateWithItems[]> => {
  return (await API.get<{ templates: CatalogTemplateWithItems[] }>(loadCatalogTemplatesEndpoint, {
    params: {
      searchQuery,
      page,
      pageSize,
      categories: categories.join(',')
    }
  })).data.templates
}

export const postCatalogItem = async (item: CatalogItemFormValues): Promise<CatalogItem> => {
  return (await API.post<CatalogItem>('/web/catalog-items', item)).data
}

export const saveCatalogItem = async (addedItem: CatalogItemFormValues): Promise<CatalogItem> => {
  try {
    return await postCatalogItem(addedItem)
  } catch (e: any) {
    message.error(e.response.data.message)
    throw e
  }
}

const laborItemPageSize = 100

export const loadLaborItems = async (): Promise<CatalogItem[]> => {
  const items: CatalogItem[] = []
  for (let page = 1; ; page += 1) {
    const pageItems = await loadItemCatalog('', page, laborItemPageSize, [ItemClasses.Labor], [], false)
    items.push(...pageItems)
    if (pageItems.length < laborItemPageSize) {
      return items
    }
  }
}

export const loadTags = async () => {
  return (await API.get<string[]>('/items/tags')).data
}

export const loadCatalogItem = async (id: number): Promise<CatalogItem> => {
  return (await API.get<CatalogItem>(`/web/catalog-items/${id}`)).data
}

export const retireCatalogItem = async (id: number): Promise<void> => {
  return API.post(`/items/retire/${id}`)
}

export const restoreCatalogItem = async (id: number): Promise<void> => {
  return API.post(`/items/restore/${id}`)
}

export const getJobsForItem = async (itemId: number): Promise<UpdateJobDescription[]> => {
  return (await API.get<UpdateJobDescription[]>(`/items/projectsForItem/${itemId}`)).data
}

export const updateJobPricingForItem = async (itemGuid: string, updateAll: boolean, jobIds: number[]): Promise<void> => {
  return API.post(`/workareas/update-job-pricing-for-catalog-item/${updateAll}/${itemGuid}`, jobIds)
}
